export default __webpack_public_path__ + "static/media/Linero3.b94ac407.png";